import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { InfoCode } from 'src/app/models/domain';

@Component({
  selector: 'em-info-codes-table',
  templateUrl: './info-codes-table.component.html',
  standalone: false,
})
export class InfoCodesTableComponent {
  @Input() public data: InfoCode[] = [];
  @Input() public errorMsg: string | undefined;
  @Input() public loading = false;

  @Output() public readonly longTextClicked = new EventEmitter<InfoCode>();

  public readonly trackByRef = trackByRef;

  public onLongTextClicked(info: InfoCode) {
    this.longTextClicked.emit(info);
  }
}
